<div class="row page-header">
    <div class="col-12">
        <h1>Safety Checklists <small>Damage, corrective action, near miss, work-alone, daily meeting, injury, and confined space forms</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Records</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-safety-checklists-dashboard></app-safety-checklists-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <ul ngbNav [(activeId)]="recordsTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Damage</a>
            </li>
            <li [ngbNavItem]="1" [destroyOnHide]="false">
                <a ngbNavLink>Corrective Action</a>
            </li>
            <li [ngbNavItem]="2" [destroyOnHide]="false">
                <a ngbNavLink>Near Miss</a>
            </li>
            <li [ngbNavItem]="3" [destroyOnHide]="false">
                <a ngbNavLink>Work Alone</a>
            </li>
            <li [ngbNavItem]="4" [destroyOnHide]="false">
                <a ngbNavLink>Daily Meeting</a>
            </li>
            <li [ngbNavItem]="5" [destroyOnHide]="false">
                <a ngbNavLink>Injury Report</a>
            </li>
            <li [ngbNavItem]="6" [destroyOnHide]="false">
                <a ngbNavLink>Confined Space</a>
            </li>
        </ul>

        <div [hidden]="!isDamageRecordsTab">
            <app-company-damage-reports></app-company-damage-reports>
        </div>
        <div [hidden]="!isCorrectiveActionRecordsTab">
            <app-safety-corrective-actions></app-safety-corrective-actions>
        </div>
        <div [hidden]="!isNearMissRecordsTab">
            <app-safety-near-misses></app-safety-near-misses>
        </div>
        <div [hidden]="!isWorkAloneRecordsTab">
            <app-safety-work-alone-auths></app-safety-work-alone-auths>
        </div>
        <div [hidden]="!isDailyMeetingRecordsTab">
            <app-daily-safety-coordination-meetings></app-daily-safety-coordination-meetings>
        </div>
        <div [hidden]="!isInjuryReportRecordsTab">
            <app-employee-injury-reports></app-employee-injury-reports>
        </div>
        <div [hidden]="!isConfinedSpaceRecordsTab">
            <app-confined-space-entry-permits></app-confined-space-entry-permits>
        </div>
    </div>
</div>
